import React from 'react';
import './index.css';

export const Label10 = ({ bold=false, disabled=false, children }) => {
    const textStyle =  { fontWeight: (bold) ? 'bold': 'normal', color: '#868ca1' };
    const cssClass = disabled ? "label10 labelDisabled" : "label10";
    return <label className={cssClass} style={textStyle}>{children}</label>;
};